"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addModal = void 0;
const react_1 = __importDefault(require("react"));
const effects_1 = require("redux-saga/effects");
const reducers_modals_reducer_1 = require("@/bit/reducers/reducers.modals-reducer");
let modalCssLoaded = false;
let Modal = null;
const composeIdByType = (id) => {
    let id2Use = id;
    const noHasAnchorTag = id.indexOf("#") === -1;
    if (noHasAnchorTag) {
        id2Use = `#${id}`;
    }
    return `${id2Use}`;
};
/*
 LISTADO => FICHA => MODAL => MODAL
                     #detalle => #seguros
        flujo ba
*/
const loadModalsCss = () => {
    if (!modalCssLoaded) {
        try {
            modalCssLoaded = true;
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = "https://prod.cms.col.movistar.es/static/ts/next13/modal.style.min.css";
            document.head.appendChild(link);
        }
        catch (err) {
            modalCssLoaded = false;
        }
    }
};
const handleModal = (Modal, show, isLastModal) => {
    if (show) {
        Modal.show();
    }
    else if (!show && isLastModal) {
        Modal.hide();
    }
};
function* addModal(data) {
    try {
        loadModalsCss();
        if (!Modal) {
            let modalImport = yield (0, effects_1.select)((state) => state.modals.modalImport);
            Modal = yield (0, effects_1.call)(() => modalImport);
            Modal = Modal.default;
        }
        const { history, fromAnchorListener } = data;
        let shouldBackHistory = true;
        let { id } = data;
        let isLastModal = true;
        let lastElement2Show = null;
        const modalHistory = yield (0, effects_1.select)((state) => state.modals.modalHistory);
        const modalHistoryLength = modalHistory.length;
        let lastModalHistoryId = "";
        if (modalHistory &&
            modalHistory.length > 0 &&
            modalHistory[modalHistoryLength - 1] &&
            modalHistory[modalHistoryLength - 1].id) {
            lastModalHistoryId = modalHistory[modalHistoryLength - 1].id;
            if (lastModalHistoryId &&
                modalHistory &&
                modalHistory[0] &&
                modalHistory[0].modalProps &&
                modalHistory[0].modalProps.historyBackOnClose !== undefined) {
                shouldBackHistory = modalHistory[0].modalProps.historyBackOnClose;
            }
        }
        const isCurrentlyOpened = id && lastModalHistoryId && lastModalHistoryId === id;
        // Modelamos el id que usaremos como ancla en la url
        id = composeIdByType(id);
        // Flag a calcular para saber si muestro u oculto modal
        let finalyShowsContent = false;
        // Flags para deducir si es nuevo contenido | volver atras | cerrar todo
        const showNewContent = id !== "#" && id !== "#closeAll";
        const closeAllContent = id === "#closeAll";
        // vemos si nos invocan con otro id diferente al anterior
        let createNavigation2 = "";
        // 1) casuistica de cerrar todo
        if (closeAllContent) {
            createNavigation2 = "#";
            finalyShowsContent = false;
            yield (0, effects_1.put)(reducers_modals_reducer_1.actions.setModalHistory([]));
        }
        // 2) creo una modal nueva
        // 2.1) me asguro de que no es la modal activa, con isCurrentlyOpened
        if (!isCurrentlyOpened && showNewContent && !closeAllContent) {
            const { Element2Show, modalProps, elementProps } = data;
            if (modalProps) {
                Modal.setModalProps(modalProps);
            }
            Modal.setContent(react_1.default.createElement(Element2Show, Object.assign({}, elementProps)));
            // apilo el nuevo contenido
            const newModalHistory = [...modalHistory, data];
            // yield put....
            yield (0, effects_1.put)(reducers_modals_reducer_1.actions.setModalHistory(newModalHistory));
            createNavigation2 = id;
            finalyShowsContent = true;
        }
        // 3) tengo que cerrar y tirar de historico
        if (isCurrentlyOpened || (!showNewContent && !closeAllContent)) {
            const newModalHistory2 = [...modalHistory];
            const newModalHistoryLength = newModalHistory2 && newModalHistory2.length;
            const lastModalIndex = newModalHistoryLength - 2;
            // me quedo el elemento que me interesa
            lastElement2Show = newModalHistory2[lastModalIndex];
            createNavigation2 = "";
            if (!lastElement2Show) {
                // esto es para simplemente cerrar modal sin crear navegación
                // limpio todo, cierro y no anclo
                finalyShowsContent = false;
                isLastModal = true;
                yield (0, effects_1.put)(reducers_modals_reducer_1.actions.setModalHistory([]));
            }
            else {
                isLastModal = false;
                const { Element2Show, elementProps, modalProps, id: lastModalId } = lastElement2Show;
                if (Element2Show && lastModalId) {
                    Modal.setModalProps(modalProps);
                    Modal.setContent(react_1.default.createElement(Element2Show, Object.assign({}, elementProps)));
                    finalyShowsContent = true;
                    newModalHistory2.pop();
                    yield (0, effects_1.put)(reducers_modals_reducer_1.actions.setModalHistory(newModalHistory2));
                }
            }
        }
        // APLICAMOS NAVEGACIÓN AL HISTORY PARA NO PERDER EL PASO
        if (createNavigation2) {
            if (createNavigation2 === "#") {
                createNavigation2 = "";
            }
            const currentUrl = new URL(window.location.href);
            const { host, pathname, protocol } = currentUrl;
            const finalCompo = `${protocol}//${host}${pathname}${createNavigation2}`;
            //router.push(finalCompo, undefined, { shallow: true });
            history.push(finalCompo);
        }
        else {
            if (!fromAnchorListener && shouldBackHistory) {
                // cuando hago back
                history.back();
            }
        }
        // El modal.show podria ir al final
        handleModal(Modal, finalyShowsContent, isLastModal);
    }
    catch (error) {
        // no debería de caer jamás
        console.error(error);
    }
}
exports.addModal = addModal;
exports.default = addModal;
//# sourceMappingURL=index.js.map